import React, { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';

import styled from '@emotion/styled';

import { PrimaryButtonAdd } from '../../Button/PrimaryButtonAdd';
import AsideModalProfileCard from '../../Card/AsideModalProfileCard';
// import ExperienceModalCard from '../../Card/ExperienceCard';
import HeaderModalProfileCard from '../../Card/HeaderModalProfileCard';

const DummyPostedJobs = [
  {
    imgSrc: '/static/gif/happyAnimal.gif',
    title: 'Pharmacist',
    name: 'Dr. Oluwake Adeleke',
    profession: 'Cardiologist',
    hospital: 'University of Ibadan Teaching Hospital',
    school: 'University of Ibadan, Oyo State',
    note: 'Remember that the AWS account ID is a 12-digit number,and its a unique identifier for your AWS account. You may need this ID when working with various AWS services, setting up permissions, or interacting with the AWS API.Keep your account ID secure, as it is sensitive information associated with your AWS account. If you need to share your AWS account information, be cautious and only share it with trusted individuals or services.',
    description:
      'A pharmacist is needed at OOUTH, sagamu for an overnight shift',
    contractDuration: 'Jan,23-Presents',
    issued: 'Issued Jun 2023',
    age: '34years',
    experience: '6years',
    location: 'Lagos, Nigeria',
    availability: 'Full Time',
    state: 'Ondo State',
    status: 'accepted',
  },
];

export interface IApplicant {
  imgSrc: string;
  title: string;
  application: string;
  status?: string;
}

interface IProfileModalProps {
  applicants?: IApplicant;
  onClose?: () => void;
}

const ProfileModal: React.FC<IProfileModalProps> = ({
  applicants,
  onClose,
}) => {
  const [viewMode, setViewMode] = useState('applicants');
  // const filteredApplicants =
  //   viewMode === 'experience' || viewMode === 'education' || viewMode === 'license'
  //   ? DummyPostedJobs.filter((applicant) => applicant.status === 'accepted')
  //   : DummyPostedJobs;
  return (
    <Container>
      <Button onClick={onClose}>
        {' '}
        <CloseIcon /> Close
      </Button>
      <Aside>
        {DummyPostedJobs.map((data, index) => (
          <AsideModalProfileCard
            imgSrc={data.imgSrc}
            name={data.name}
            profession={data.profession}
            note={data.note}
          />
        ))}
      </Aside>
      <Applicant>
        <Header>
          {DummyPostedJobs.map((data, index) => (
            <HeaderModalProfileCard
              age={data.age}
              experience={data.experience}
              location={data.location}
              availability={data.availability}
            />
          ))}
        </Header>
        <Information>
          <Buttons>
            <PrimaryButtonAdd
              className={`pl-pr-4 noBorder ${
                viewMode === 'applicants' ? 'active' : ''
              }`}
              onClick={() => setViewMode('experience')}
              isActive={viewMode === 'experience'}
            >
              Experience
            </PrimaryButtonAdd>
            <PrimaryButtonAdd
              className={` pl-pr-4 noBorder ${
                viewMode === 'screening' ? 'active' : ''
              }`}
              onClick={() => setViewMode('education')}
              isActive={viewMode === 'education'}
            >
              Education
            </PrimaryButtonAdd>
            <PrimaryButtonAdd
              className={` pl-pr-4 noBorder ${
                viewMode === 'interview' ? 'active' : ''
              }`}
              onClick={() => setViewMode('license')}
              isActive={viewMode === 'license'}
            >
              Licenses & Certifications
            </PrimaryButtonAdd>
          </Buttons>
          <Br />
          {DummyPostedJobs.map((data, index) => (
            // <ExperienceModalCard
            //   key={index}
            //   imgSrc={data.imgSrc}
            //   title={data.title}
            //   hospital={data.hospital}
            //   profession={data.profession}
            //   availability={data.availability}
            //   contractDuration={data.contractDuration}
            //   issued={data.issued}
            //   state={data.state}
            //   school={data.school}
            //   viewMode={viewMode}
            // />
            <></>
          ))}
        </Information>
      </Applicant>
    </Container>
  );
};

export default ProfileModal;

const Container = styled.div`
  display: flex;
  gap: 2rem;
  padding: 4rem;
  background-color: white;
  // border: 1px solid blue;
  border-radius: 0.5rem;
`;

const Aside = styled.div`
  width: 20rem;
`;

const Header = styled.div`
  margin-bottom: 1.5rem;
`;

const Buttons = styled.div`
  display: flex;
  margin-bottom: 10px;
  gap: 3rem;
  // border: 1px solid blue;
`;

const Applicant = styled.div``;

const Information = styled.div`
  padding: 2rem;
  padding-bottom: 4rem;
  box-shadow: 0px 20px 26px 0px rgba(186, 182, 182, 0.16);
`;

const Button = styled.button`
  position: absolute;
  top: 1rem;
  right: 3rem;
  background: none;
  display: flex;
  border: none;
  font-size: 1rem;
  cursor: pointer;
`;

const CloseIcon = styled(AiOutlineClose)`
  background-color: black;
  position: relative;
  bottom: -0.3rem;
  left: -0.2rem;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 3px;
  align-items: center;
`;

const Br = styled.hr`
  width: 108%;
  margin-left: -2rem;
  border: 0.2px solid #ddd;
`;
